import { MedicalCaseDocument } from '../../../domain/medical-case/model/medical-case-document';
import { MedicalCaseDocumentType } from '../../../domain/medical-case/model/medical-case-document-type';
import {
  MedicalCasePhaseDocumentState,
  MedicalCasePhases,
} from '../../../domain/medical-case/model/medical-case-phase';
import { MedicalCaseDocumentUploadPhase } from '../../../domain/medical-case/model';

export type MedicalCasePreparationFileStatus =
  | 'uploading'
  | 'uploaded'
  | 'error';

export interface MedicalCasePreparationFileEntry {
  clientId: string;
  file?: File;
  fileName: string;
  originalFileName: string;
  size: number | null;
  extension: string | null;
  url: string | null;
  fileId: string | null;
  status: MedicalCasePreparationFileStatus;
  progress: number;
  canDelete: boolean;
documentId: string | null;
  versionId: string | null;
  include: boolean;
  documentCategory: MedicalCaseDocumentType | null;
  documentDate: string | null;
  metadataSaving: boolean;
  phaseStateOverride: MedicalCasePhaseDocumentState | null;
  uploadPhase: MedicalCaseDocumentUploadPhase | null;
}

export namespace MedicalCasePreparationFilesActions {
  const prefix = '[MedicalCasePreparationFiles]';

  export class SeedFromCaseDetail {
    static readonly type = `${prefix} Seed from case detail`;

    constructor(
      readonly caseId: string,
      readonly documents: MedicalCaseDocument[],
      readonly phases?: MedicalCasePhases
    ) {}
  }

  export class AddLocalFile {
    static readonly type = `${prefix} Add local file`;

    constructor(
      readonly caseId: string,
      readonly entry: MedicalCasePreparationFileEntry
    ) {}
  }

  export class UpdateProgress {
    static readonly type = `${prefix} Update progress`;

    constructor(
      readonly caseId: string,
      readonly clientId: string,
      readonly progress: number
    ) {}
  }

  export class MarkUploaded {
    static readonly type = `${prefix} Mark uploaded`;

    constructor(
      readonly caseId: string,
      readonly clientId: string,
      readonly document: MedicalCaseDocument
    ) {}
  }

  export class MarkError {
    static readonly type = `${prefix} Mark error`;

    constructor(
      readonly caseId: string,
      readonly clientId: string
    ) {}
  }

  export class SetUploading {
    static readonly type = `${prefix} Set uploading`;

    constructor(
      readonly caseId: string,
      readonly clientId: string
    ) {}
  }

  export class Remove {
    static readonly type = `${prefix} Remove`;

    constructor(
      readonly caseId: string,
      readonly clientId: string
    ) {}
  }

  export class UpdateMetadata {
    static readonly type = `${prefix} Update metadata`;

    constructor(
      readonly caseId: string,
      readonly clientId: string,
      readonly patch: Partial<
        Pick<
          MedicalCasePreparationFileEntry,
          | 'fileName'
          | 'include'
          | 'documentCategory'
          | 'phaseStateOverride'
        >
      >
    ) {}
  }

  export class SetMetadataSaving {
    static readonly type = `${prefix} Set metadata saving`;

    constructor(
      readonly caseId: string,
      readonly clientId: string,
      readonly pending: boolean
    ) {}
  }

  export class ClearCase {
    static readonly type = `${prefix} Clear case`;

    constructor(readonly caseId: string) {}
  }
}
